import { z } from "zod";

import { defaultItem, itemSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const skillSchema = itemSchema.extend({
  name: z.string(),
  description: z.string(),
  level: z.coerce.number().min(0).max(5).default(0).describe("0-5, set to 0 is not level provided"),
  keywords: z.array(z.string()).default([]),
});

export const minimalSkillSchema = skillSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Skill = z.infer<typeof skillSchema>;
export type MinimalSkill = z.infer<typeof minimalSkillSchema>;

// Defaults
export const defaultSkill: Skill = {
  ...defaultItem,
  name: "",
  description: "",
  level: 1,
  keywords: [],
};

export const deminimalizeSkill = (skill: MinimalSkill): Skill => {
  return {
    ...defaultSkill,
    ...skill,
    id: createId(),
  };
};
